<fd-dispatcher fd-dispatcher-action="{
    type: 'APPROVAL.DENY',
    approvalType: $ctrl.type,
    batch: $ctrl.batch
  }"><catch><wc-toast ng-init="$ctrl.catch()" wc-toast-message="Error denying changes"></wc-toast></catch><then><wc-toast ng-init="$ctrl.then()" wc-toast-message="Changes denied"></wc-toast></then></fd-dispatcher>